import { render, staticRenderFns } from "./CreatorPaidShare.vue?vue&type=template&id=ddf2371e&"
import script from "./CreatorPaidShare.vue?vue&type=script&lang=js&"
export * from "./CreatorPaidShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports